import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { SidebarOption } from '../../interfaces/components';
import SidebarItem from '../SideBarItem';
import { sidebarOptions } from '../common/Overlay';
import { Box } from '@chakra-ui/react';

export default function MobileMenu() {
  const [activeView, setActiveView] = useState('home');

  useEffect(() => {
    const activeSidebarOption = sidebarOptions.find(
      (sidebarOption: SidebarOption) => sidebarOption.href === location.pathname,
    );

    activeSidebarOption ? setActiveView(activeSidebarOption.key) : setActiveView('');
  }, [location.pathname]);
  return (
    <Box
      h="68px"
      width="100%"
      padding="14px 12px"
      display="flex"
      borderRadius="20px"
      border="1px solid rgba(0, 0, 0, 0.10)"
      background="#FFF"
      // border="1px solid red"
    >
      {sidebarOptions.map((sideBarOption: SidebarOption) => (
        <NavLink to={sideBarOption.href} key={sideBarOption.key} style={{ flexGrow: 1 }}>
          <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" width="100%">
            <SidebarItem
              sideBarItemKey={sideBarOption.key}
              sideBarIcon={sideBarOption.sideBarIcon}
              text={sideBarOption.text}
              active={activeView === sideBarOption.key}
              setActiveView={() => setActiveView(sideBarOption.key)}
            />
          </Box>
        </NavLink>
      ))}
    </Box>
  );
}
